import { useEffect, useState } from 'react';
import api from '../api/axios';
import CompanyFormModal from '../components/CompanyFormModal';
import '../styles/companiespage.css';

export default function CompaniesPage() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    setLoading(true);
    const res = await api.get('/companies');
    setCompanies(res.data.companies);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (c) => {
    if (!window.confirm(`Delete "${c.shortName}"? This cannot be undone.`)) return;
    await api.delete(`/companies/${c._id}`);
    load();
  };

  return (
    <div className="hpc-page">
      <div className="hpc-topbar">
        <h1 className="hpc-title">Companies</h1>
        <button className="hpc-btn hpc-btn--primary" onClick={() => { setEditing(null); setModalOpen(true); }}>
          <PlusIcon /> Add Company
        </button>
      </div>

      <div className="hpc-table-card">
        {loading ? (
          <div className="hpc-state">
            <div className="hpc-spinner" aria-hidden="true" />
            <p>Loading companies…</p>
          </div>
        ) : companies.length === 0 ? (
          <div className="hpc-state">
            <BuildingIcon />
            <p>No companies yet. Add your first one to start generating offer letters.</p>
          </div>
        ) : (
          <table className="hpc-table">
            <thead>
              <tr>
                <th>Company</th>
                <th>Sender Email</th>
                <th>Contact</th>
                <th>Letterhead</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {companies.map((c) => (
                <tr key={c._id}>
                  <td>
                    <div className="hpc-company-cell">
                      <span className="hpc-swatch" style={{ background: c.accentColor }} />
                      <div>
                        <div className="hpc-company-name">{c.shortName}</div>
                        <div className="hpc-company-full">{c.fullName}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    {c.smtpUser ? c.smtpUser : <span className="hpc-unset">not set</span>}
                  </td>
                  <td className="hpc-muted">{c.contactPhone}</td>
                  <td>
                    {c.letterheadPath ? (
                      <div className="hpc-letterhead-wrap">
                        <img src={c.letterheadPath} alt={`${c.shortName} letterhead`} className="hpc-letterhead-thumb" />
                        <span className="hpc-letterhead-hint">Hover to preview</span>
                        <div className="hpc-letterhead-preview">
                          <img src={c.letterheadPath} alt={`${c.shortName} letterhead — full preview`} />
                        </div>
                      </div>
                    ) : (
                      <span className="hpc-unset">none</span>
                    )}
                  </td>
                  <td>
                    <div className="hpc-row-actions">
                      <button className="hpc-btn hpc-btn--outline hpc-btn--sm" onClick={() => { setEditing(c); setModalOpen(true); }}>
                        <EditIcon /> Edit
                      </button>
                      <button className="hpc-btn hpc-btn--danger hpc-btn--sm" onClick={() => handleDelete(c)}>
                        <TrashIcon /> Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modalOpen && (
        <CompanyFormModal
          existing={editing}
          onClose={() => setModalOpen(false)}
          onSaved={() => { setModalOpen(false); load(); }}
        />
      )}
    </div>
  );
}

function PlusIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <line x1="12" y1="4" x2="12" y2="20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="4" y1="12" x2="20" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function EditIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 20h9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function TrashIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 7h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M9 7V4h6v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 7l1 13h10l1-13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function BuildingIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="5" y="3" width="10" height="18" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="15" y="9" width="6" height="12" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
